export function getPublicArticleNumber(articleNumber: string | null | undefined) {
    return articleNumber && !/^__/.test(articleNumber) ? articleNumber : undefined;
}

export function isMenuCategory(itemId: string) {
    return /^CATEGORY-/.test(itemId);
}

/**
 * Resolves a menu/item thumbnail to an absolute URL using session base URLs.
 * Use when thumbnail may be stored as a relative path (e.g. when reusing session after model selector).
 */
export function resolveThumbnailUrl(
    thumbnail: string | null | undefined,
    iconUrl: string | undefined,
    publicOutUrl: string | undefined
): string | undefined {
    if (!thumbnail) return undefined;
    if (/^https?:\/\//i.test(thumbnail)) return thumbnail;
    const base = /^colorpost_icons/.test(thumbnail) ? publicOutUrl ?? "" : iconUrl ?? publicOutUrl ?? "";
    return base + thumbnail;
}
